"use client";

import dynamic from "next/dynamic";
import { Loader2 } from "lucide-react";

const BracketViewerSkeleton = () => (
  <div className="flex items-center justify-center h-96">
    <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
  </div>
);

export const ViewerBracketView = dynamic(
  () => import("./viewer-view").then((mod) => mod.ViewerBracketView),
  {
    loading: BracketViewerSkeleton,
    ssr: false,
  },
);
